// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3gvQ5","footer":"Form_footer__3mjBV"};